var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString } from 'class-validator';
export class CreatePartnersAgencyDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "name", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "phoneNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "companyAddress", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "companyRegistrationImage", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "companyRegistrationNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "managerName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "managerPhoneNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "representativeName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePartnersAgencyDto.prototype, "representativePhoneNumber", void 0);
